import { Stack, Typography, Alert, Button, CircularProgress } from '@mui/material';
import { Storage as StorageIcon } from '@mui/icons-material';
import { useI18nContext } from '@/i18n/i18n-react';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { setSubmitting } from '@/store/installSlice';
import { usePostInstallStepMutation } from '@/store/apiSlice';

export const DatabaseStep = () => {
    const { LL } = useI18nContext();
    const dispatch = useAppDispatch();

    const { formData, submitting } = useAppSelector((state) => state.install);
    const [postInstallStep] = usePostInstallStepMutation();

    const handleDatabaseInstall = async () => {
        dispatch(setSubmitting(true));

        try {
            const data = await postInstallStep({
                step: 'database',
                adminAuthCode: formData.adminAuthCode,
                events: formData.events,
            }).unwrap();

            if (data.success) {
                setTimeout(() => {
                    window.location.href = '/';
                }, 3000);
            }
        } catch (err: any) {
            console.error('Database install failed:', err);
        } finally {
            dispatch(setSubmitting(false));
        }
    };

    return (
        <Stack spacing={3}>
            <Typography variant="body2" color="text.secondary">
                {LL.install.database.description()}
            </Typography>

            <Alert severity="warning">
                <strong>{LL.install.database.warningTitle()}</strong>{' '}
                {LL.install.database.warningMessage()}
            </Alert>

            <Button
                variant="contained"
                color="success"
                size="large"
                fullWidth
                disabled={submitting}
                onClick={handleDatabaseInstall}
                startIcon={
                    submitting ? <CircularProgress size={20} color="inherit" /> : <StorageIcon />
                }
            >
                {submitting
                    ? LL.install.database.installing()
                    : LL.install.database.installButton()}
            </Button>
        </Stack>
    );
};
